import type { ReactNode } from "react";
import { formatDateTimeLocal } from "@/shared/lib/date-time";

export type PrintDocumentShellProps = {
  title: string;
  children: ReactNode;
  extraFooterLine?: ReactNode;
  /** Stable id for print/CSS targeting (e.g. payslip vs form) */
  rootId?: string;
};

/**
 * Shared letterhead + footer for browser print / “Save as PDF” flows.
 * Matches HR payroll preview styling.
 */
export function PrintDocumentShell({
  title,
  children,
  extraFooterLine,
  rootId = "print-document-content",
}: PrintDocumentShellProps) {
  return (
    <div
      id={rootId}
      className="mx-auto max-w-4xl bg-white p-8 font-serif text-gray-900 leading-relaxed print:max-w-none print:p-0 print:font-serif print:text-gray-900 print:leading-relaxed"
      style={{
        fontFamily: '"Times New Roman", Times, serif',
        lineHeight: "1.5",
        color: "#1a1a1a",
      }}
    >
      <div className="mb-8 border-gray-800 border-b-4 pb-6 print:mb-6">
        <div className="mb-6 text-center">
          <h1 className="font-bold text-4xl text-gray-800 uppercase tracking-wider">
            FREEDOM Sole Co.Ltd
          </h1>
          <p className="mt-2 text-gray-600 text-lg">{title}</p>
          <div className="mx-auto mt-4 h-1 w-24 bg-gray-800" />
        </div>
      </div>

      {children}

      <div className="mt-12 border-gray-300 border-t-2 pt-6 text-center text-gray-600 text-sm">
        <p>ເອກະສານນີ້ຖືກສ້າງອັດຕະໂນມັດໂດຍລະບົບ Freedom ERP</p>
        <p className="mt-1">
          ວັນທີພິມ: {formatDateTimeLocal(new Date())}
          {extraFooterLine ? " | " : ""}
          {extraFooterLine}
        </p>
      </div>
    </div>
  );
}
